module.exports = __webpack_public_path__ + "img/image5@2x.7777d7c9.png";